import { LayoutComponents } from "@jelly/lesson";
import config from "appConfig";

const components: LayoutComponents = [
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/25/principle/visco-thermal-dist-9m.svg`,
        },
      },
    },
  },
];

export default components;
